import { autoinject } from 'aurelia-framework';
import { Device } from "../models/device";

@autoinject
export class WaterTank {
	device: Device;
	parent: any;
	//levelStyle: string;
	//levelColor: string;
	//level: string;

	constructor() {
		//this.levelColor = "water-tank-blue";
		//this.levelStyle = "tank-70";
		//this.level = "70%";
	}

	bind(bindingContext: any, overrideContext: any) {
		this.device = bindingContext.device;
		this.parent = bindingContext;
	}

}